<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-blue">
          <div class="card-text">
            <h4 class="title">Creación de Ticket</h4>
          </div>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              Nombre Completo
            </label>
            <div class="md-layout-item">
              <ValidationProvider
                name="fullName"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[
                    { 'md-error': failed },
                    { 'md-valid': passed },
                    { 'md-form-group': false }
                  ]"
                >
                  <md-input v-model="ticket.fullName" type="text"></md-input>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
          </div>
          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              Tipo y Número de Documento
            </label>
            <div class="md-layout-item md-size-35">
              <ApolloQuery
                :query="require('../../graphql/query/DomainGroup.gql')"
                :variables="{ fieldName: Constants.DOMAIN_DOC_TYPE }"
                ><template v-slot="{ result: { data } }">
                  <ValidationProvider
                    name="capDomainDocType"
                    rules="required"
                    v-slot="{ passed, failed }"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label for="select">Tipo de Documento</label>
                      <md-select
                        v-if="data"
                        v-model="capDocumentType"
                        name="select"
                      >
                        <md-option
                          v-for="docType in data.getDomain"
                          :key="docType.id"
                          :value="docType.id"
                          >{{ docType.value }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </ValidationProvider>
                </template>
              </ApolloQuery>
            </div>
            <div class="md-layout-item md-size-50">
              <!-- actualizat valor mínimo a 1000000 -->
              <ValidationProvider
                name="documentValue"
                rules="required|max_value:9999999999|min_value:100000"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[
                    { 'md-error': failed },
                    { 'md-valid': passed },
                    { 'md-form-group': false }
                  ]"
                >
                  <md-input
                    v-model="ticket.documentValue"
                    placeholder="Número de Documento"
                    type="text"
                  ></md-input>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field></ValidationProvider
              >
            </div>
          </div>
          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              Número de contacto
            </label>
            <div class="md-layout-item">
              <ValidationProvider
                name="cellphone"
                rules="required|max_value:3999999999|min_value:3000000000"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[
                    { 'md-error': failed },
                    { 'md-valid': passed },
                    { 'md-form-group': false }
                  ]"
                >
                  <md-input v-model="ticket.cellphone" type="text"></md-input>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field></ValidationProvider
              >
            </div>
          </div>

          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              Correo
            </label>
            <div class="md-layout-item">
              <ValidationProvider
                name="cellphone"
                rules="required|email"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[
                    { 'md-error': failed },
                    { 'md-valid': passed },
                    { 'md-form-group': false }
                  ]"
                >
                  <md-input v-model="ticket.email"></md-input>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
          </div>

          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              Asunto
            </label>
            <div class="md-layout-item md-size-35">
              <ApolloQuery
                :query="require('../../graphql/query/DomainGroup.gql')"
                :variables="{ fieldName: Constants.DOMAIN_TICKET_TYPE }"
                ><template v-slot="{ result: { data } }">
                  <ValidationProvider
                    name="capDomainTicketType"
                    rules="required"
                    v-slot="{ passed, failed }"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label for="select">Asunto</label>
                      <md-select
                        v-if="data"
                        v-model="capDomainTicketType"
                        name="select"
                      >
                        <md-option
                          v-for="docType in data.getDomain"
                          :key="docType.id"
                          :value="docType.id"
                          >{{ docType.value }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </ValidationProvider>
                </template>
              </ApolloQuery>
            </div>

            <div
              v-if="capDomainTicketType == Constants.OTHER_TICKET_TYPE"
              class="md-layout-item"
            >
              <md-field>
                <md-input v-model="ticket.subject" type="text"></md-input>
                <span class="md-helper-text"
                  >Escriba brevemente el asunto.</span
                >
              </md-field>
            </div>
          </div>
          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              Solicitud
            </label>
            <div class="md-layout-item">
              <md-field maxlength="5">
                <label>Describe el objetivo de este ticket</label>
                <md-textarea v-model="ticket.body"></md-textarea>
              </md-field>
            </div>
          </div>
          <div class="text-right">
            <md-button class="md-info md-round" @click="createTicket()">
              Crear Ticket
              <md-icon>keyboard_arrow_right</md-icon>
            </md-button>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import Constants from "../../constants";
import gql from "graphql-tag";
import Swal from "sweetalert2";
export default {
  components: {},
  data() {
    return {
      ticket: {
        fullName: null,
        subject: null,
        body: null,
        cellphone: null,
        email: null,
        documentValue: null
      },
      Constants: Constants,
      capDocumentType: null,
      capDomainTicketType: null,
      ticketTypes: null
    };
  },
  created() {
    this.$apollo
      .query({
        query: gql`
          query getDomain($fieldName: String!) {
            getDomain(fieldName: $fieldName) {
              id: domId
              name: fieldName
              value: fieldValue
            }
          }
        `,
        variables: {
          fieldName: "Tipo de ticket"
        }
      })
      .then(data => {
        this.ticketTypes = data.data.getDomain;
      });
  },
  methods: {
    createTicket() {
      if (this.capDomainTicketType != Constants.OTHER_TICKET_TYPE)
        this.ticket.subject = this.ticketTypes.filter(a => {
          return a.id == this.capDomainTicketType;
        })[0].value;
      this.$apollo
        .mutate({
          mutation: gql`
            mutation createTicket($ticket: pTicket!, $capDocumentType: Int!) {
              createTicket(ticket: $ticket, capDocumentType: $capDocumentType) {
                ticketId
                body
                cellphone
                documentValue
                email
                fullName
                ticketCode
              }
            }
          `,
          variables: {
            ticket: this.ticket,
            capDocumentType: this.capDocumentType
          },
          update: (cache, mutationResult) => {
            let ticketResult = mutationResult.data.createTicket;
            Swal.fire({
              title: "Ticket creado",
              text:
                "Tu ticket se ha registrado con código " +
                ticketResult.ticketCode,
              confirmButtonClass: "md-button md-primary",
              buttonsStyling: false
            }).then(() => {
              this.$router.push("/edit-ticket/" + ticketResult.ticketCode);
              this.$router.go();
            });
          }
        })
        .catch(error => {
          Constants.catchError(
            error,
            this.$apollo.provider.defaultClient,
            this,
            false
          );
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.form-control-static {
  margin-top: 6px;
}
</style>
